/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Job_Completion_HelpInputs */

const en_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive an email notification any time an AI Transcription or AI Translation job completes successfully.`)
};

const fr_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recevez un email à chaque fin de tâche de transcription IA ou de traduction IA.`)
};

const de_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie erhalten eine E-Mail-Benachrichtigung, sobald ein KI-Transkriptions- oder KI-Übersetzungsauftrag erfolgreich abgeschlossen wurde.`)
};

const it_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi una notifica via email ogni volta che un lavoro di trascrizione o traduzione AI viene completato correttamente.`)
};

const ru_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте уведомления по электронной почте всякий раз, когда задание по транскрипции или переводу с помощью ИИ успешно завершается.`)
};

const es_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reciba una notificación por correo electrónico cada vez que un trabajo de transcripción o traducción de IA se complete con éxito.`)
};

const zh_cn2_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI转录或AI翻译任务成功完成后，您将收到电子邮件通知。`)
};

const ja_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI トランスクリプションまたは AI 翻訳ジョブが正常に完了するたびに、電子メール通知を受け取ります。`)
};

const hi_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब भी कोई एआई ट्रांसक्रिप्शन या एआई ट्रांसलेशन का काम सफलतापूर्वक पूरा हो जाए, तो आपको ईमेल के माध्यम से सूचना मिल जाएगी।`)
};

const pt_pt2_options_notifications_job_completion_help = /** @type {(inputs: Options_Notifications_Job_Completion_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba uma notificação por e-mail sempre que uma tarefa de transcrição ou tradução por IA for concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Receive an email notification any time an AI Transcription or AI Translation job completes successfully." |
*
* @param {Options_Notifications_Job_Completion_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_job_completion_help = /** @type {((inputs?: Options_Notifications_Job_Completion_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Job_Completion_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_job_completion_help(inputs)
	if (locale === "de") return de_options_notifications_job_completion_help(inputs)
	if (locale === "it") return it_options_notifications_job_completion_help(inputs)
	if (locale === "ru") return ru_options_notifications_job_completion_help(inputs)
	if (locale === "es") return es_options_notifications_job_completion_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_job_completion_help(inputs)
	if (locale === "ja") return ja_options_notifications_job_completion_help(inputs)
	if (locale === "hi") return hi_options_notifications_job_completion_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_job_completion_help(inputs)
	return en_options_notifications_job_completion_help(inputs)
});